/* eslint-disable consistent-return */
import shave from 'shave';
import Quill from 'quill';
import tippy from 'tippy.js';
import purify from 'dompurify';
import validate from 'validator';
// eslint-disable-next-line import/no-cycle
import { ajax } from './fetch';
import { dispatch } from '../store/store-utils';
import {
  updateBillingUser,
  updateExceedQuota,
  updateUserPlan
} from '../store/reducers/plan-reducer';

export const ENTER = 13;
export const UPARROW = 38;
export const DOWNARROW = 40;
export const DATE_CHECK_TAKEAWAY = 1654599600000;
const LEFTARROW = 37;
const RIGHTARROW = 39;
const COMMA = 32;
const SPACE = 9;
const TAB = 188;
const CONTROL = 91;
const COMMAND = 17;
export const supportedFileExtensions = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.dat',
  '.csv',
  '.exe',
  '.odt',
  '.pptx',
  '.dat',
  '.cr2',
  '.csv',
  '.pdf',
  '.odp',
  '.txt',
  '.zip',
  '.mp4',
  '.mp3',
  '.tiff',
  '.avif',
  '.jpg',
  '.jpeg',
  '.png',
  '.avi',
  '.mov',
  '.m4v',
  '.m4a',
  '.webm',
  '.mpeg',
  '.wav',
  '.svg',
  '.bz2',
  '.gif',
  '.webp'
];

export function convToHoursMins(totMins) {
  if (totMins) {
    const hours = Math.floor(totMins / 60);
    const mins = totMins % 60;
    let totalMins = 0;

    if (hours > 0) totalMins = `${hours}h${mins > 0 ? ` ${mins}m` : ''}`;
    else totalMins = `${mins}m`;

    return totalMins;
  }
  return '0m';
}

export function convToMinsSec(totSeconds) {
  try {
    if (totSeconds) {
      const hours = Math.floor(totSeconds / 3600);
      const mins = Math.floor((totSeconds % 3600) / 60);
      const seconds = Math.floor((totSeconds % 3600) % 60);

      return [hours, mins, seconds]
        .map((v) => (v < 10 ? `0${v}` : v))
        .filter((v, i) => v !== '00' || i > 0)
        .join(':');
    }
  } catch (err) {
    console.error(
      `Exception while converting seconds to HH:MM format :: ${err.message}`
    );
  }
  return '00:00';
}

export function convToSecs(time) {
  try {
    if (time) {
      const s = time.split(':');
      let seconds;
      if (s.length > 3 || s.length < 1) return 0;

      if (s.length === 3) seconds = +s[0] * 60 * 60 + +s[1] * 60 + +s[2];

      if (s.length === 2) seconds = +s[0] * 60 + +s[1];

      if (s.length === 1) seconds = +s[0];

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(seconds)) return 0;
      return seconds;
    }
  } catch (err) {
    console.error(
      `Exception while converting minutes to seconds :: ${err.message}`
    );
  }
  return 0;
}
export function getMode() {
  const mode = new Set();
  mode.add('LIVE');
  mode.add('MINT');
  // mode.add('STAGING');

  return mode;
}

export function scrollTo(pageOffset) {
  setTimeout(() => {
    window.scrollTo({ top: pageOffset });
  }, 2);
}

export function isAdminView(userSemanticName) {
  try {
    let adminView = false;

    if (
      userSemanticName &&
      userSemanticName !== 'null' &&
      userSemanticName !== ''
    )
      adminView = true;

    return adminView;
  } catch (err) {
    return false;
  }
}

export function findClosetParentViaClass(elem, className) {
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.classList && elem.classList.contains(className)) return elem;
  }
  return null;
}
export function getAllSiblings(elem) {
  const sibArr = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      sibArr.push(sibling);
    }

    sibling = sibling.nextSibling;
  }
  return sibArr;
}

export function path(pathName) {
  const pathMap = {};

  const pathArr = pathName.split('/');

  if (pathArr) {
    if (pathArr[1]) pathMap.univ = pathArr[1];

    if (
      pathArr[2] &&
      !auPage().has(pathArr[2]) &&
      pathArr[3] &&
      pathArr[3] !== 'learning'
    ) {
      pathMap.track = pathArr[1];
      if (pathArr[3]) pathMap.page = pathArr[3];
      if (pathArr[4]) pathMap.content = pathArr[4];
    } else {
      pathMap.page = pathArr[2];
      if (pathArr[3]) pathMap.content = pathArr[3];
    }
  }
  return pathMap;
}

export function statusMsg(message, status, component) {
  if (status && message) {
    const statusTemplate = document.createElement('template');
    statusTemplate.innerHTML = `<div class="voice-box">
                                  <span></span>
                                </div>`;

    const statusElement = statusTemplate.content.cloneNode(true);
    statusElement.querySelector('.voice-box').querySelector('span').innerHTML =
      message;

    statusElement
      .querySelector('.voice-box')
      .classList.remove(status === 'warning' ? 'success' : 'warning');

    statusElement.querySelector('.voice-box').classList.add(status);

    if (component && component.querySelector('.voice-box')) {
      component.querySelector('.voice-box').remove();
      clearTimeout();
    }
    if (component) component.appendChild(statusElement);

    setTimeout(() => {
      if (component && component.querySelector('.voice-box'))
        component.querySelector('.voice-box').remove();
    }, 3e3);
  }
}

export function capitalize(value) {
  if (!value) return '';
  const words = value.toLowerCase().split(' ');
  const capitalizedString = words
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    })
    .join(' ');

  return capitalizedString;
}

export function inputFilterLimit(textbox, limit, targetParent) {
  textbox.addEventListener('input', (e) => {
    const countdown = findClosetParentViaClass(
      e.target,
      targetParent
    ).querySelector('.linktitle-countdown');

    if (e.target.classList.contains('error'))
      e.target.classList.remove('error');

    if (
      e.target.value &&
      ((limit > 30 && e.target.value.length > limit - 30) ||
        (limit < 30 && e.target.value.length > limit - 5))
    ) {
      countdown.style.display = 'block';
      countdown.querySelector('span').innerHTML = limit - e.target.value.length;

      if (e.target.value.length > limit) e.target.classList.add('error');
    } else if (countdown.style.display === 'block')
      countdown.style.display = 'none';
  });
}

export function getHostName(url, match) {
  match = url.match(/:\/\/(www\d?\.)?(.[^/:]+)/i);

  if (
    match != null &&
    match.length > 2 &&
    typeof match[2] === 'string' &&
    match[2].length > 0
  )
    return match[2];
  return null;
}

export function isValidEmail(email) {
  return validate.isEmail(email);
}

export function isValidDomain(domain) {
  const match = /^(?:.+\s)?@\w+/i;
  return match.test(domain);
}

export function isValidNumber(value) {
  return Number.isInteger(value);
}

export function getFileSize(byte) {
  const i = Math.floor(Math.log(byte) / Math.log(1024));
  const value = (byte / 1000 ** i).toFixed(2) * 1;
  return { value, i };
}

export function getPendingDays(value) {
  const days = Math.floor(
    (new Date().getTime() - value) / (24 * 60 * 60 * 1000)
  );

  return days > 0 ? `${days} days` : 'Invited today';
}

export function inputFilterOnlyNumbers(textbox) {
  [
    'input',
    'keydown',
    'keyup',
    'mousedown',
    'mouseup',
    'select',
    'contextmenu',
    'drop'
  ].forEach((event) => {
    textbox.addEventListener(event, (e) => {
      if (!e) return;
      const targetElement = e.target;
      const inputFilter =
        /^\d*$/.test(targetElement.value) &&
        (targetElement.value === '' ||
          (parseInt(targetElement.value, 10) > 0 &&
            parseInt(targetElement.value, 10) <= 10000));

      if (targetElement.classList.contains('error'))
        targetElement.classList.remove('error');

      if (inputFilter) {
        targetElement.oldValue = targetElement.value;
        targetElement.oldSelectionStart = targetElement.selectionStart;
        targetElement.oldSelectionEnd = targetElement.selectionEnd;
      } else if (
        Object.prototype.hasOwnProperty.call(targetElement, 'oldValue')
      ) {
        targetElement.value = targetElement.oldValue;
        targetElement.setSelectionRange(
          targetElement.oldSelectionStart,
          targetElement.oldSelectionEnd
        );
      }
    });
  });
}

export function addTippy(placement = 'top') {
  // Add tippy for name
  tippy('.tippy', {
    arrow: true,
    duration: 300,
    size: 'small',
    maxWidth: '240',
    animation: 'shift-toward',
    placement
  });
}

export function updateTippy(elem, newVal) {
  const tippyElem = elem._tippy;
  if (tippyElem) {
    tippyElem.set({
      content: newVal
    });
  }
  elem.classList.add('tippy');
  elem.setAttribute('data-tippy-content', newVal);
}

export function textEditor(elem, placeholder) {
  const toolbarOptions = [
    [
      'bold',
      'italic',
      'underline',
      'link',
      { list: 'ordered' },
      { list: 'bullet' }
    ]
  ];

  const editorOptions = {
    theme: 'bubble',
    modules: {
      toolbar: toolbarOptions
    },
    strict: true,
    placeholder,
    scrollingContainer: '.ql-editor',
    bounds: elem
  };

  const editor = new Quill(elem, editorOptions);

  editor.root.removeAttribute('data-gramm');
}

export function lineShave(elem, val) {
  shave(elem, val, { spaces: false });
}

export function autoResize(element) {
  const elemHeight = element.offsetHeight - element.clientHeight;
  element.style.height = `${element.scrollHeight + elemHeight}px`;
  element.style.height = 'auto';
}

export function checkValidUrl(value) {
  if (value.indexOf('<iframe') !== -1) return true;

  return validate.isURL(value, { require_protocol: false });
}

export function sanitizeName(name) {
  try {
    if (!name) return;
    const htmlTagPattern = /<[^>]*>/g;
    const partialTagPattern = /<[a-zA-Z]+/g;
    try {
      name = decodeURI(name);
    } catch (e) {
      console.error(`Error in decoding input string:: ${e.message}`);
    }
    let unescapedName = validate.unescape(name);

    if (!unescapedName && !typeof unescapedName === 'string') return;
    unescapedName = unescapedName.replaceAll('&lt', '&lt;');
    unescapedName = unescapedName.replaceAll('&gt', '&gt;');
    unescapedName = validate.unescape(unescapedName);
    let sanitizedName = unescapedName.replaceAll(htmlTagPattern, '');

    sanitizedName = sanitizedName.replaceAll(partialTagPattern, '');
    sanitizedName = purify.sanitize(sanitizedName, {
      ALLOWED_TAGS: []
    });

    sanitizedName = validate.unescape(sanitizedName);
    return sanitizedName;
  } catch (e) {
    console.error(`Error in sanitizing input string:: ${e.message}`);
  }
}

export function sanitizeText(value) {
  return purify.sanitize(value);
}

export function validateAndModifyYouTubeUrl(url) {
  // regular expression to match YouTube video URLs
  const ytUrlPattern =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})(?:\S+)?$/;
  // check if URL matches the YouTube video URL pattern
  if (!ytUrlPattern.test(url)) {
    return null;
  }
  // remove the "t=" parameter from the URL suffix
  const modifiedUrl = url.replace(/[&?]?t=[^&]+/, '');
  return modifiedUrl;
}

export function getYouTubeId(url) {
  if (url) {
    if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) {
      const youtubeRegEx =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

      const id = url.trim().match(youtubeRegEx) ? RegExp.$1 : false;

      if (id) {
        return {
          id,
          type: 'youtube'
        };
      }
      return {
        id: '',
        type: 'other'
      };
    }
    return {
      id: '',
      type: 'other'
    };
  }
}

export function isValidEmbedLink(url, embedRegEx) {
  if (url) {
    if (url.indexOf('iframe') !== -1) {
      embedRegEx = /^(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/;

      return embedRegEx.test(url.trim());
    }
  }
  return false;
}

export function addScheme(url) {
  if (url) {
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
  }
  return url;
}

export function timestampToDate(timestamp) {
  const currentDate = new Date();

  const expectedDate = new Date(timestamp);

  const diff = currentDate.getFullYear() - expectedDate.getFullYear();

  const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  if (!diff)
    return `${expectedDate.getDate()} ${month[expectedDate.getMonth()]}`;
  return `${expectedDate.getDate()} ${month[expectedDate.getMonth()]}
   ${expectedDate.getFullYear()}`;
}

export function getDateWithYear(timestamp) {
  const expectedDate = new Date(timestamp);

  const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  return `${expectedDate.getDate()} ${month[expectedDate.getMonth()]}
   ${expectedDate.getFullYear()}`;
}

export function timestampToDaysOrDate(timestamp) {
  const currentDate = new Date();

  const expectedDate = new Date(timestamp);

  const diffYear = currentDate.getFullYear() - expectedDate.getFullYear();

  const diffDay = parseInt(
    (currentDate.getTime() - expectedDate.getTime()) / (24 * 3600 * 1000),
    10
  );

  const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  if (!diffDay) {
    let diffDate =
      Math.abs(currentDate.getTime() - expectedDate.getTime()) / 1000;

    const hours = Math.floor(diffDate / 3600) % 24;

    diffDate -= hours * 3600;

    const minutes = Math.floor(diffDate / 60) % 60;

    return `${
      hours > 0
        ? `${hours} ${hours > 1 ? 'hrs' : 'hr'} ${minutes} ${
            minutes > 1 ? 'mins' : 'min'
          } ago`
        : minutes > 0
        ? `${minutes} ${minutes > 1 ? 'mins' : 'min'} ago`
        : ''
    }`;
  }

  // if (!diffDay) return Math.abs(currentDate.getTime() - expectedDate.getTime()) / 36e5;

  if (!diffYear)
    return `${month[expectedDate.getMonth()]} ${expectedDate.getDate()}`;
  return `${
    month[expectedDate.getMonth()]
  } ${expectedDate.getDate()} ${expectedDate.getFullYear()}`;
}

export function linkImageLinks() {
  const linkImg = [
    'https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/images/default-blue.svg',
    'https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/images/default-yellow.svg',
    'https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/images/default-voilet.svg',
    'https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/images/default-pink.svg',
    'https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/images/default-green.svg'
  ];

  return linkImg[Math.floor(Math.random() * linkImg.length)];
}

export function isSpecialChar(text) {
  const format = /[!@#$%^&*()_+\-=[\]{};':"|,.<>/?]/;
  return format.test(text);
}

export function checkIfAtleastThreeCharacters(text) {
  const pattern = new RegExp(/(.*[a-z]){3}/i);
  return pattern.test(text);
}

export function tagComponent(ulElem, liClass, inputVal, type) {
  const templateTag = document.createElement('template');
  let template;

  templateTag.innerHTML =
    '<li class="tag-name tag-close"><span></span><cite id="close"></cite></li>';

  const templateInviteName = document.createElement('template');

  templateInviteName.innerHTML = `<li class = "invite-name"><span></span><cite class="close"></cite></li>`;

  const templateDomain = document.createElement('template');

  templateDomain.innerHTML = `<li class="domain-name"><span></span><cite class="close"></cite></li>`;

  if (type === 'tag') template = templateTag;
  else if (type === 'email' || type === 'user') template = templateInviteName;
  else if (type === 'domain') template = templateDomain;

  type === 'email'
    ? (template.content
        .querySelector('.invite-name')
        .querySelector('span').innerHTML = inputVal)
    : (template.content.querySelector('span').innerHTML = inputVal);

  ulElem.insertBefore(
    template.content.cloneNode(true),
    ulElem.querySelector(liClass)
  );

  return template.content.cloneNode(true);
}

export function getValues(ulElem, liClass, elemArray, liElem) {
  elemArray = [];
  liElem = ulElem.querySelectorAll(liClass);

  liElem.forEach((val) => {
    if (val.querySelector('span').innerHTML.trim() !== '')
      elemArray.push(val.querySelector('span').innerHTML.trim().toLowerCase());
  });

  return elemArray;
}

export function attachCloseHandler(elem) {
  elem.querySelector('cite').addEventListener('click', (e) => {
    e.target.parentElement.remove();
  });
}

export function movFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('video/quicktime');
  fileFormat.add('video/x-quicktime');
  fileFormat.add('image/mov');
  fileFormat.add('audio/aiff');
  fileFormat.add('audio/x-midi');
  fileFormat.add('audio/x-wav');
  fileFormat.add('video/avi');
  return fileFormat;
}

export function mp4FileFormat() {
  const fileFormat = new Set();
  fileFormat.add('video/mp4');
  fileFormat.add('application/mp4');
  return fileFormat;
}

export function oggFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('audio/ogg');
  fileFormat.add('video/ogg');
  return fileFormat;
}

export function wmvFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('video/x-ms-wmv');
  fileFormat.add('video/x-ms-asf');
  return fileFormat;
}

export function webmFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('video/webm');
  fileFormat.add('audio/webm');
  return fileFormat;
}

export function mpegFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('audio/mpeg3');
  fileFormat.add('audio/x-mpeg-3');
  fileFormat.add('video/mpeg');
  fileFormat.add('video/x-mpeg');

  return fileFormat;
}

export function wavFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('audio/wav');
  fileFormat.add('audio/x-wav');

  return fileFormat;
}

export function aviFileFormat() {
  const fileFormat = new Set();
  fileFormat.add('application/x-troff-msvideo');
  fileFormat.add('video/avi');
  fileFormat.add('video/x-msvideo');

  return fileFormat;
}
export function checkNetworkIsConnected() {
  if (!navigator.onLine)
    statusMsg(
      'Err... Network seems to be disconnected!',
      'warning',
      document.querySelector('au-main')
    );
}

export function keyupForInvite() {
  const keys = new Set();
  keys.add(ENTER);
  keys.add(SPACE);
  keys.add(TAB);
  keys.add(COMMA);

  return keys;
}

export function keyupForCopyAndPaste() {
  const keys = new Set();
  keys.add(COMMAND);
  keys.add(CONTROL);

  return keys;
}

export function keyEventForArrows() {
  const keys = new Set();
  keys.add(LEFTARROW);
  keys.add(RIGHTARROW);
  keys.add(UPARROW);
  keys.add(DOWNARROW);

  return keys;
}

export function hideEmptyState() {
  document
    .querySelector('.main-container')
    .classList.remove('empty-without-button');
  document
    .querySelector('.main-container')
    .classList.remove('empty-with-button');
}

export function getStepElementAttributes(
  node,
  array,
  eachStep,
  watchedProgress
) {
  const eachSubStepAndProgress = {};

  const subStep = {};
  const subProgress = {};

  subStep.key = node.getAttribute('key');
  if (node.nodeName) subStep.type = node.nodeName.split('-')[1].toLowerCase();

  if (subStep.type === 'video') {
    watchedProgress = {};
    watchedProgress.elapsed = node.getAttribute('elapsed');
    subProgress.details = JSON.stringify(watchedProgress);
  }
  if (subStep.type === 'takeaway') {
    subProgress.details = htmlTrim(node.querySelector('.ql-editor'));
  }

  eachSubStepAndProgress.subStep = subStep;
  eachSubStepAndProgress.subProgress = subProgress;

  return eachSubStepAndProgress;
}

export function removeItemFromArray(array, item) {
  if (array && item) {
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);

      return true;
    }
  }

  return false;
}

export function htmlTrim(reviewInput) {
  const size = reviewInput.querySelectorAll('*').length;
  const arrayOfElements = reviewInput.querySelectorAll('*');

  for (let i = 0; i < size; i += 1) {
    const node = arrayOfElements[i];
    if (node.textContent.trim() === '') {
      const tempText = node.textContent.replace(
        new RegExp('<p><br></p>', 'g'),
        ''
      );
      const emptyPTag = tempText.replace(/\s|&nbsp;/g, '');

      if (!tempText || !emptyPTag) node.remove();
    } else break;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = size; i--; ) {
    const node = arrayOfElements[i];
    if (node.textContent.trim() === '') {
      const tempText = node.textContent.replace(
        new RegExp('<p><br></p>', 'g'),
        ''
      );

      if (node && node.localName === 'p' && !tempText) node.remove();
    } else break;
  }
  autoResize(reviewInput);

  return reviewInput.innerHTML;
}

export function findInArray(targetArray, searchValue) {
  // assuming everything is string
  const result = targetArray.find(
    (val) =>
      val.replace(/\s/g, '').toLowerCase() ===
      searchValue.replace(/\s/g, '').toLowerCase()
  );

  if (!result) return false;
  return true;
}

export function fetchLinkDetails(embedResp, embedComponent, request) {
  embedComponent.querySelector('.link-step').classList.add('loader');

  embedComponent
    .querySelector('.link-step')
    .querySelector('a')
    .setAttribute('href', embedResp['sub-step'].details);

  embedComponent
    .querySelector('.embed-description')
    .querySelector('span').innerHTML = getHostName(
    embedResp['sub-step'].details
  );

  if (embedComponent.getAttribute('mode') === 'create')
    embedComponent.querySelector('.embed-link').value =
      embedResp['sub-step'].details;

  request = {};

  request.contentType = 'application/json; charset=utf-8';
  request.method = 'POST';
  request.url = '/api/v1/link-details';
  request.body = {
    url: embedResp['sub-step'].details
  };

  ajax(request).then((response) => {
    if (document.querySelector('.card-innerview'))
      document.querySelector('.card-innerview').classList.remove('load-step'); // remove it after fetching link details

    if (response?.status) {
      if (response.data.link.image)
        embedComponent
          .querySelector('.step-image')
          .setAttribute('src', response.data.link.image);

      if (response.data.name)
        embedComponent
          .querySelector('.embed-description')
          .querySelector('h1').innerHTML = response.data.name;

      if (response.data.description)
        embedComponent
          .querySelector('.embed-description')
          .querySelector('p').innerHTML = response.data.description;
    } else {
      embedComponent.querySelector('.link-step').classList.add('error');
    }
    embedComponent.querySelector('.link-step').classList.remove('loader');
  });
}

export function getName(user) {
  if (
    typeof user.firstName !== 'undefined' &&
    user.firstName &&
    typeof user.lastName !== 'undefined' &&
    user.lastName
  )
    return `${user.firstName.trim()} ${user.lastName.trim()}`;
  if (typeof user.firstName !== 'undefined' && user.firstName)
    return user.firstName.trim();
  return '';
}

export function isComponentScroll(elemContainer) {
  if (
    elemContainer.scrollTop + elemContainer.offsetHeight + 500 >=
    elemContainer.scrollHeight
  ) {
    return true;
  }
  return false;
}

export function searchConstant() {
  const displayLi = {
    DEFAULTCOUNT: 2
  };
  return displayLi;
}

export function auPage() {
  const page = new Set();
  page.add('home');
  page.add('courses');
  page.add('people');
  page.add('search');
  page.add('link');
  page.add('course');
  page.add('tag');
  page.add('reports');

  return page;
}

export function auOuterPage() {
  const page = new Set();
  page.add('home');
  page.add('courses');
  page.add('people');
  page.add('search');
  page.add('tag');
  page.add('reports');

  return page;
}

export function auInnerPage() {
  const page = new Set();
  page.add('course');
  page.add('link');

  return page;
}

export function auContentType() {
  const contentType = new Set();
  contentType.add('audio');
  contentType.add('video');
  contentType.add('book');
  contentType.add('article');

  return contentType;
}

export function auPageWithOutSideBar() {
  const page = new Set();
  page.add('search');
  page.add('link');
  page.add('course-preview');
  page.add('course');
  page.add('tag');

  return page;
}

export function getCoursePageName() {
  const page = 'course-v2';

  return page;
}

export function auContent() {
  const content = new Set();
  content.add('learning');
  content.add('queue');
  content.add('recommended');
  content.add('reports');

  return content;
}

export function isBindNavigateLink(e, link) {
  if (e.shiftKey || e.ctrlKey || e.metaKey) {
    window.open(link, '_blank');
    return true;
  }

  return false;
}

export function htmlDecode(actValue) {
  const txt = document.createElement('textarea');
  txt.innerHTML = actValue;
  return txt.value;
}

export function htmlEncode(actValue) {
  const txt = document.createElement('textarea');
  txt.value = actValue;
  return txt.innerHTML;
}

export function _bindUpAndDownArrow(elem, keyCode) {
  try {
    const elemParent = findClosetParentViaClass(elem, 'dropdown');
    let activeLiIndex;
    let totalLiLength = 0;
    const totalLi = elemParent.querySelectorAll('.search-result');

    totalLiLength = totalLi.length;

    if (totalLiLength > 0) {
      for (let i = 0; i < totalLiLength; i += 1) {
        if (totalLi[i].classList.contains('active')) {
          activeLiIndex = i;
          break;
        }
      }

      if (activeLiIndex === undefined) {
        totalLi[0].classList.add('active');
      }

      // if (activeLiIndex == 0) totalLi[activeLiIndex].classList.add('active');
      else if (keyCode === 38 && activeLiIndex !== 0) {
        totalLi[activeLiIndex].classList.remove('active');

        totalLi[activeLiIndex - 1].classList.add('active');
      } else if (keyCode === 40 && activeLiIndex + 1 !== totalLiLength) {
        totalLi[activeLiIndex].classList.remove('active');
        totalLi[activeLiIndex + 1].classList.add('active');
      }
      // const elementHeight = elemParent
      //   .querySelector('.dropdown-menu')
      //   .querySelector('nav')
      //   .querySelector('.dropdown-list').clientHeight;

      // elemParent.querySelector('.dropdown-menu').querySelector('nav').scrollTop =
      //   elementHeight * activeLiIndex;

      const elementHeight = elemParent
        .querySelector('.dropdown-menu')
        .querySelector('nav')
        .querySelector('.dropdown-list').clientHeight;

      const elementOffset = elemParent
        .querySelector('.dropdown-menu')
        .querySelector('nav')
        .querySelector('.active').offsetTop;

      const containerHeight =
        elemParent.querySelector('.dropdown-menu').clientHeight;

      if (elementOffset > containerHeight) {
        const scrollValue = elementOffset - elementHeight;
        elemParent
          .querySelector('.dropdown-menu')
          .querySelector('nav').scrollTop = scrollValue;
      } else {
        elemParent
          .querySelector('.dropdown-menu')
          .querySelector('nav').scrollTop = 0;
      }
    }
  } catch (e) {
    console.error(`Error while doing key down up:: ${e.message}`);
  }
}

export function predictKey(e) {
  const key = e.which || e.keyCode;
  if (key === DOWNARROW || key === UPARROW) {
    _bindUpAndDownArrow(e.target, key);
  }
}

export function validSearchInput(val) {
  if (val) {
    const searchVal = val.trim();
    if (
      !searchVal ||
      (searchVal && (searchVal === '' || searchVal.length <= 2))
    )
      return false;
    return true;
  }
  return false;
}

// returns true if it has value, or false if it doesnt have value

export function isNullOrEmpty(val) {
  if (val) {
    if (typeof val !== 'string') {
      val = val.toString();
    }
    const searchVal = val.trim();
    if (!searchVal || (searchVal && searchVal === '')) return false;
    return true;
  }
  return false;
}

export function isNotNullOrEmpty(val) {
  if (val) {
    if (typeof val !== 'string') {
      val = val.toString();
    }
    const searchVal = val.trim();
    if (!searchVal || (searchVal && searchVal === '')) return false;
    return true;
  }
  return false;
}

export function getSourceForLink() {
  let source;

  if (window.pathMap.track) source = window.pathMap.track;
  else source = window.pathMap.univ;

  return source;
}

export function createTrack(track) {
  const sidebarTrackCard = document.createElement('au-track-sidebar');

  document
    .querySelector('.track-list')
    .querySelector('nav')
    .appendChild(sidebarTrackCard);

  sidebarTrackCard.setAttribute('semanticname', track.semanticName);

  sidebarTrackCard.setAttribute('name', track.name);

  sidebarTrackCard.setAttribute('image', track.image);

  return sidebarTrackCard;
}

export function checkDevice() {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    window.innerWidth <= 1020
  ) {
    return true;
  }
  return false;
}

export function isSuperAdmin() {
  const isAdmin = false;
  try {
    if (window.univ.roleDTO.semanticName) {
      if (window.univ.roleDTO.semanticName === 'super-admin') return true;
    }
  } catch (err) {
    console.error(`Exception while checking super admin ${err}`);
  }
  return isAdmin;
}

export function isElementOnViewport(elementPosition) {
  const windowHeight = window.innerHeight;
  const windowScrollY = window.scrollY;
  const scrollPosition = windowScrollY + windowHeight;

  if (scrollPosition > elementPosition) return true;
}

export const roles = {
  SUPER_ADMIN: 'super-admin',
  ADMIN: 'admin',
  USER: 'user'
};

export const peopleConstants = {
  DIRECTORY: 'directory',
  LEADERBOARD: 'leaderboard'
};

export const DATE_CHECK_YOUTUBEVIDEO = 1645612200000;

export function imageExt() {
  const imageExtSet = new Set();
  imageExtSet.add('image/png');
  imageExtSet.add('image/apng');
  imageExtSet.add('image/bmp');
  imageExtSet.add('image/gif');
  imageExtSet.add('image/x-icon');
  imageExtSet.add('image/jpeg');
  imageExtSet.add('image/svg+xml');
  imageExtSet.add('image/tiff');
  imageExtSet.add('image/webp');

  return imageExtSet;
}

export const msMimeTypes = [
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];

export const ooMimeTypes = [
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.text-template',
  'application/vnd.oasis.opendocument.text-web',
  'application/vnd.oasis.opendocument.text-master',
  'application/vnd.oasis.opendocument.graphics',
  'application/vnd.oasis.opendocument.graphics',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.presentation-template',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.spreadsheet-template',
  'application/vnd.oasis.opendocument.chart',
  'application/vnd.oasis.opendocument.formula',
  'application/vnd.oasis.opendocument.database',
  'application/vnd.oasis.opendocument.image',
  'application/vnd.openofficeorg.extension',
  'application/vnd.sun.xml.writer',
  'application/vnd.sun.xml.writer.template',
  'application/vnd.sun.xml.calc',
  'application/vnd.sun.xml.calc.template',
  'application/vnd.sun.xml.draw',
  'application/vnd.sun.xml.draw.template',
  'application/vnd.sun.xml.impress',
  'application/vnd.sun.xml.impress.template',
  'application/vnd.sun.xml.writer.global',
  'application/vnd.sun.xml.math',
  'application/vnd.stardivision.writer',
  'application/vnd.stardivision.writer-global',
  'application/vnd.stardivision.calc',
  'application/vnd.stardivision.draw',
  'application/vnd.stardivision.impress',
  'application/vnd.stardivision.impress-packed',
  'application/vnd.stardivision.math',
  'application/vnd.stardivision.chart',
  'application/vnd.stardivision.mail',
  'application/x-starwriter',
  'application/x-starcalc',
  'application/x-stardraw',
  'application/x-starimpress',
  'application/x-starmath',
  'application/x-starchart'
];

export const permissions = {
  ADD_PEOPLE: 'add-people',
  RECOMMEND_LINK: 'recommend-link'
};

export function removeDropdownFromWindow() {
  // if search is open, and if it doesnt have search value, then make it close
  const searchDropdown = document.querySelector('au-search-dropdown');

  document.querySelectorAll('.open').forEach((elem) => {
    if (
      elem.classList.contains('dropdown') &&
      !elem.classList.contains('search-list')
    )
      elem.classList.remove('open');
    if (
      elem.classList.contains('au-search') &&
      window.pathMap.page !== 'search'
    ) {
      searchDropdown.setAttribute('mode', 'close');
      searchDropdown.setAttribute('dropdown', 'close');
    }
  });

  if (window.pathMap && window.pathMap.page !== 'search') {
    searchDropdown?.setAttribute('dropdown', 'close');
    searchDropdown?.setAttribute('query', '');
    searchDropdown?.setAttribute('mode', 'close');
  }
}

export function prependZero(number) {
  if (number || number === 0) {
    if (number.toString().length === 1) {
      return `0${number}`;
    }
    return `${number}`;
  }
}

export function getDateText(epochMilliseconds) {
  const date = new Date(epochMilliseconds);
  if (date.toString() !== 'Invalid Date') {
    const dateString = date.toString().split(' ')[2];
    const monthString = date.toString().split(' ')[1];
    const yearString = date.toString().split(' ')[3];
    return `${dateString} ${monthString} ${yearString}`; // ${getTimeText(epochMilliseconds)}`;
  }
}

export function getTimeText(epochMilliseconds) {
  const date = new Date(epochMilliseconds);
  if (date.toString() !== 'Invalid Date') {
    const dateHours = date.getHours();
    if (dateHours <= 12) {
      return `${prependZero(dateHours === 0 ? 12 : dateHours)}:${prependZero(
        date.getMinutes()
      )} AM`;
    }
    return `${prependZero(dateHours - 12)}:${prependZero(
      date.getMinutes()
    )} PM`;
  }
}

export function myQContent() {
  const content = new Set();
  content.add('inprogress');
  content.add('completed');
  content.add('queue');
  content.add('recommended');
  content.add('pinned');
  content.add('reports');

  return content;
}

export function peopleContent() {
  const content = new Set();
  content.add('leaderboard');
  content.add('directory');
  content.add('pending-invite');

  return content;
}

export function invitePopUp() {
  const content = new Set();
  content.add('invite-tab');
  content.add('share-tab');

  return content;
}

export function closeDropdown() {
  ['keydown', 'click'].forEach((event) => {
    document.addEventListener(event, (e) => {
      // for window onclick
      if (event === 'click') {
        // close all dropdowns, on click outside the window
        if (
          !e.target.classList.contains('dropdown') &&
          findClosetParentViaClass(e.target, 'dropdown') == null
        ) {
          // if search is open, and if it doesnt have search value, then make it close
          removeDropdownFromWindow();
        }

        // for closing the sidebar on click of document in mobile
        if (
          checkDevice() &&
          !e.target.classList.contains('menu-icon') &&
          !e.target.classList.contains('menu-bar')
        )
          if (document.querySelector('.au').classList.contains('sidebar-open'))
            document.querySelector('.au').setAttribute('class', 'au');

        // if network is down indicate its down //supported in major browsers
        // checkNetworkIsConnected();
      }
    });
  });
}

export const getAnywhereUniversityName = () => {
  return 'anywhereworks';
};

export const checkIsFull = (univName) => {
  if (univName && univName === getAnywhereUniversityName()) return true;
  return false;
};

export const updatePlanInfoInStore = (
  planInfo,
  isBillingUser,
  exceedBooleans
) => {
  dispatch(updateUserPlan(planInfo));
  dispatch(updateBillingUser(isBillingUser));
  dispatch(updateExceedQuota(exceedBooleans));
};

export const universityListForTracks = () => {
  const univList = [
    getAnywhereUniversityName(),
    'missouri-bootheel-regional-consortium-inc',
    'kansas-city-college-of-cybersecurity-cloud-engineering',
    'loan-connection-llc',
    'au-support-videos',
    'teamdda',
    'sage-pest-control-u'
  ];

  return univList;
};

export const getWeeklyMinsDateFromAndTo = () => {
  const date = new Date();
  let first = -6; // First day is the day of the month - the day of the week
  let last = 0; // last day is the first day + 6

  if (date.getDay() > 0) {
    first = 1 - date.getDay();
    last = 7 - date.getDay();
  }

  const mondayDate = new Date(
    new Date().getTime() +
      parseInt(parseInt(first, 10) * 24 * 60 * 60 * 1000, 10)
  );

  const sundayDate = new Date(
    new Date().getTime() +
      parseInt(parseInt(last, 10) * 24 * 60 * 60 * 1000, 10)
  );

  let arr = [];

  arr = mondayDate.toString().split(' ');
  const startDate = new Date(
    `${arr[2]} ${arr[1]} ${arr[3]} 00:00:00`.trim()
  ).getTime();

  arr = sundayDate.toString().split(' ');
  const endDate = new Date(
    `${arr[2]} ${arr[1]} ${arr[3]} 23:59:59`.trim()
  ).getTime();

  const dates = {
    startDate,
    endDate
  };

  return dates;
};

export const fetchTrack = async (univSemanticName, trackSemanticName) => {
  try {
    const request = {};

    request.contentType = 'application/json; charset=utf-8';
    request.url = `/api/v1/university/${univSemanticName}/track/${trackSemanticName}`;
    request.method = 'GET';

    return await ajax(request);
  } catch (e) {
    console.error(`Error while creating course/link:: ${e.message}`);
    return {};
  }
};

export function isNumeric(str) {
  return /^-?\d+$/.test(str);
}

export function isValidJsonResponse(res) {
  return res.headers.get('content-type')?.includes('application/json');
}
